import {
  useCompositeGroup
} from "../__chunks/6FAQA4RZ.js";
import "../__chunks/2NIRKFVH.js";
import "../__chunks/F5VAC7MB.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import "../__chunks/PNRLI7OV.js";

// src/combobox/combobox-group.ts
var useComboboxGroup = createHook((props) => {
  props = useCompositeGroup(props);
  return props;
});
var ComboboxGroup = createComponent((props) => {
  const htmlProps = useComboboxGroup(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  ComboboxGroup.displayName = "ComboboxGroup";
}
export {
  ComboboxGroup,
  useComboboxGroup
};
